import { Nullable } from "../../types";

export enum SymptomsTypes {
    NONE = "None",
    DYSPNEA = "Dyspnea",
    CHEST_PAIN = "Chest pain",
    LEG_PAIN = "Leg pain",
    GENERAL_FATIGUE = "General fatigue",
}

export enum RPEScales {
    TEN = "1 - 10",
    TWENTY = "6 - 20",
}

export interface SymptomsDataFromAPI {
    type: SymptomsTypes[];
    rest_ecg: string[] | null;
    exercise_ecg: string[] | null;
    all_ecg_types: string[];
    recovery_ecg: string[] | null;
    rpe_scale: Nullable<RPEScales>;
    rpe_value: Nullable<number>;
}

export interface Symptoms {
    exercise_ecg: string[];
    rest_ecg: string[];
    recovery_ecg: string[];
    all_ecg_types: string[];
    type: SymptomsTypes[];
    rpeScale: Nullable<RPEScales>;
    rpeValue: Nullable<number>;
}
